import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/dist/sweetalert2.css";

export function PopUpModal(msg, id) {
  Swal.fire({
    title: "",
    icon: "success",
    html: `<div style="color: #008000;">${msg}</div><b>${id}</b>`,
    focusConfirm: false,
    confirmButtonText: "OK",
  });
}

export function isValidMobileNumber(value) {
  if (value !== "") {
    const pattern = /^[1-9]\d{9}$/; // Example for a 10-digit mobile number
    return pattern.test(value);
  } else {
    return true;
  }
}

export const showNotification = (type, message) => {
  const titles = {
    success: "Success",
    error: "Error",
    warning: "Warning",
    info: "Info",
  };

  Swal.fire(titles[type] || "Notification", message, type);
};
